import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
class StackCaptchaModule extends VuexModule {
  show: boolean = false;
  id: string | null = null;
  value: string | null = null;
  confirm: boolean = false;

  public get showCaptcha(): boolean {
    return this.show || false;
  }
  public get idCaptcha(): string {
    return this.id || "";
  }
  public get valueCaptcha(): string {
    return this.value || "";
  }
  public get confirmCaptcha(): boolean {
    return this.confirm || false;
  }

  @Mutation
  setShowCaptcha(show: boolean = false) {
    this.show = show;
  }
  @Mutation
  setIdCaptcha(id: string|null = null) {
    this.id = id;
  }
  @Mutation
  setValueCaptcha(value: string|null = null) {
    this.value = value;
  }
  @Mutation
  setConfirmCaptcha(confirm: boolean = false) {
    this.confirm = confirm;
  }
}

export default StackCaptchaModule;
